import { render, staticRenderFns } from "./good.vue?vue&type=template&id=1a231426&scoped=true&"
import script from "./good.vue?vue&type=script&lang=js&"
export * from "./good.vue?vue&type=script&lang=js&"
import style0 from "./good.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./good.vue?vue&type=style&index=1&id=1a231426&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a231426",
  null
  
)

export default component.exports